module.exports = __webpack_public_path__ + "static/media/proj14_img2.cb57519f.jpg";